import { memo } from "react";
import type { NavigationMenuLinkProps as RadixNavigationMenuLinkProps } from "@radix-ui/react-navigation-menu";
import { NavigationMenuLink } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
import Link, { LinkProps } from "next/link";
import { ArrowRight, ChevronRight } from "lucide-react";
import Image from "next/image";

export type NavigationSubmenuItemWithIconProps = {
  icon: string | undefined;
  isActive?: boolean;
  ref?: React.Ref<HTMLAnchorElement | null>;
} & RadixNavigationMenuLinkProps &
  React.ComponentPropsWithoutRef<"a"> &
  LinkProps;

const NavigationSubmenuItemWithIcon = ({
  className,
  href = "#",
  ref,
  isActive,
  icon,
  title,
  children,
  ...rest
}: NavigationSubmenuItemWithIconProps) => {

  return (
    <div>
      <NavigationMenuLink asChild>
        <Link
          href={href}
          passHref
          ref={ref}
          className={cn(
            "grid grid-cols-[0.12fr_1fr] flex-row w-[500px] items-center group hover:!bg-none hover:!bg-transparent select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none",
            className
          )}
          {...rest}
        >
          <div
            className={cn("flex justify-center items-center", {
              "group-hover:bg-[#4381E5] bg-[#F7F9FD] rounded-full w-10 h-10":
                !!icon,
            })}
          >
            {!!icon && (
              <Image
                src={icon}
                alt="icon"
                width={24}
                height={24}
                className="group-hover:brightness-0 group-hover:invert transition"
              />
            )}
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex gap-2 text-[16px] group-hover:text-[#4381E5] font-medium leading-none">
              {title}
              <ArrowRight
                color="#4381E5"
                className=" group-hover:flex hidden"
              />
            </div>
            <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
              {children}
            </p>
          </div>
        </Link>
      </NavigationMenuLink>
    </div>
  );
};

export default memo(NavigationSubmenuItemWithIcon);
